<template>
  <div class="container">
    <div>需要通过此手机号获取你的短信验证码</div>
    <div class="input-content">
      <div class="form-item">
        <span class="label">手机号码</span>
        <div class="input-item" style="background:#eee">
          <input
            type="number"
            v-model="mobile"
            :placeholder="userInfo.phone | encryptPhone"
            maxlength="11"
            disabled
          />
        </div>
      </div>
      <div class="form-item">
        <span class="label">验证码</span>
        <div class="input-item">
          <div class="d-flex flex-row w-100">
            <input
              class="flex-1"
              type="mobile"
              v-model="code"
              placeholder="请输入6位验证码"
              placeholder-class="input-empty"
              maxlength="6"
              @confirm="bindPhone"
            />
            <div class="get-code flex-center text-nowrap" @click="getCode">
              {{ codeTime != 60 ? codeTime + "秒后重新获取" : "获取验证码" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="confirm-btn" @click="bindPhone" :disabled="logining">
      下一步
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      mobile: "",
      logining: false,
      code: "",
      codeTime: 60,
    };
  },
  filters: {
    encryptPhone(phone) {
      let str2 = ''
      if (phone) {
        let str = phone.slice(3, 9);
        str2 = phone.replace(str, "******");
      }
      return str2;
    },
  },

  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    bindPhone() {
      let { code } = this;
      this.logining = true;
      this.$http
        .request(this.$http.pathMap.verifyPhoneCode, "post", {
          phone: this.userInfo.phone,
          vcode: code,
        })
        .then((res) => {
          this.$router.push("/pages/user/newOldPwd");
          this.logining = false;
        })
        .catch((err) => {
          this.logining = false;
        });
    },
    getCode() {
      if (this.codeTime != 60) {
        return;
      }
      let that = this;
      this.$http
        .request(this.$http.pathMap.forgetVcode, "get", { phone: this.userInfo.phone })
        .then((res) => {
          this.$toast("验证码发送成功");
          let interval = setInterval(() => {
            if (that.codeTime > 1) {
              that.codeTime -= 1;
            } else {
              that.codeTime = 60;
              clearInterval(interval);
            }
          }, 1000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px;
  background: #f8f8f8;
}
.input-content {
  margin-top: 20px;
}
.form-item {
  margin-bottom: 10px;
}
.input-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 15px;
  background: #fff;
  height: 60px;
  border-radius: 4px;
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
  .tit {
    height: 25px;
    line-height: 28px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-base;
  }
  input {
    height: 30px;
    font-size: $uni-font-size-base + 1px;
    color: $font-color-dark;
    width: 100%;
  }
}
.get-code {
  border: 1px $base-color solid;
  border-radius: 25px;
  color: $base-color;
  font-size: $uni-font-size-sm + 1px;
  padding-left: 5px;
  padding-right: 5px;
}
.confirm-btn {
  width: 315px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  border-radius: 50px;
  margin: 35px auto;
  background: $base-color;
  color: white;
  font-size: $uni-font-size-lg;
  &:after {
    border-radius: 100px;
  }
}
</style>
